export default Object.freeze({
  ADD_REBATE: 'ADD REBATE',
  UPDATE_APPLICANT: 'UPDATE APPLICANT',
  UPDATE_TIER: 'UPDATE TIER',
});
